import classnames from 'classnames';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import classes from './index.module.scss';

import type { PropsWithChildren, ReactNode } from 'react';

interface IMaskLoadingProps extends PropsWithChildren {
  className?: string;
  type?: 'full' | 'container' | 'normal';
  size?: 'large' | 'small' | 'default';
  tip?: ReactNode;
}

const MaskLoading = (props: IMaskLoadingProps) => {
  const { type = 'normal', size = 'large', tip, className } = props;

  return (
    <div
      className={classnames('MaskLoading', classes.wrap, className, {
        [classes.full]: type === 'full',
        [classes.container]: type === 'container',
      })}>
      <div className={classes.loading}>
        <Spin
          size={size}
          indicator={
            <LoadingOutlined className={classes.icon} style={{ fontSize: 32 }} spin={true} />
          }
          tip={tip}
        />
      </div>
    </div>
  );
};

export default MaskLoading;
